// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__fYqjP","chip__button":"styles_chip__button__YIy2r","chip--disabled":"styles_chip--disabled__ulKs-"};